//INI INE(JJGJ) 20221018 - REQ22978
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../util/base-service.service';
import { HttpConst } from '../resources/http/http.const';

@Injectable()
export class ConfiguracionesService extends BaseService {

  private $api = `${HttpConst.apiUrl}`;
  private $controllerName = 'Configuracion';

  constructor(private http: HttpClient) { super(http); }


  ListarConfiguraciones() {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/ListarConfiguraciones`,null);
    return resultado;
  }

}

//FIN INE(JJGJ) 20221018 - REQ22978
